const convertOpacityToHex = require('../convertOpacityToHex');

/**
 * Adds 2 digit opacity hex to 6 digit color hex
 * @param {String} color - The given color to add opacity
 * @param {Number} opacity - The wished opacity
 * @param {Boolean} disableAlpha - Whether or not to set opacity
 * @return {String}
 */
const addOpacityToHex = (color, opacity = 1, disableAlpha = false) => {
    if (disableAlpha || opacity === 1 || color.length >= 8) {
        return color;
    }

    return color + convertOpacityToHex(opacity);
};

module.exports = addOpacityToHex;
